import endpoints from 'api/endpoints';
import { api } from 'api/rest';

export class VersionService {
  static async updateVersion() {
    const response = await api.put(endpoints.versions);
    return response;
  }
}
